import React, { createContext } from "react";

export interface FormContextValue {
  variant: "wide" | "narrow";
  customRenderers?: Record<string, React.ComponentType<any>>;
}

export const FormContext = createContext<FormContextValue>({
  variant: "wide",
});
